// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__RbB2I","label":"styles_label__JXYMO","days":"styles_days__CInKk"};